import type { ReactNode } from 'react';

/** Page-level Setup section: bold title + one-line description, then content. */
export function SetupSection({
  id,
  title,
  description,
  badge,
  children,
}: {
  /** Anchor id — becomes `setup-{id}` (used by the section nav). */
  id: string;
  title: string;
  description?: string;
  badge?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section
      id={`setup-${id}`}
      aria-labelledby={`setup-${id}-title`}
      className="flex min-w-0 scroll-mt-4 flex-col gap-3"
    >
      <div>
        <div className="flex items-center gap-2.5">
          <h2 id={`setup-${id}-title`} className="text-[18px] font-bold">
            {title}
          </h2>
          {badge}
        </div>
        {description ? (
          <p className="text-muted-foreground mt-0.5 text-[13px]">
            {description}
          </p>
        ) : null}
      </div>
      {children}
    </section>
  );
}
